<template>
  <div class="web-page">
    <div class="logo-box pa-4 app-header">
      <div class="logo">
        <img style="max-width: 280px" src="../assets/logo.png" alt />
        <div class="header_title ma-2">{{ $t(`name`) }}</div>
      </div>
      <!-- <div class="lang-btn">
          <span
            class="language-button"
            @click="changeLang('zh-Hant')"
            :class="{ 'lang-active': $i18n.locale === 'zh-Hant' }"
            >繁</span
          >
          <span
            class="language-button"
            @click="changeLang('pt')"
            :class="{ 'lang-active': $i18n.locale === 'pt' }"
            >PT</span
          >
        </div> -->
    </div>
    <div class="web-page__content" :class="{ 'has-footer': hasFooter }">
      <slot></slot>
    </div>
    <div>
      <div v-if="hasFooter" class="web-page-actions pa-4">
        <div class="web-page-actions__content">
          <slot name="actions"></slot>
        </div>
      </div>
      <div class="web-page-footer">
        <div class="web-page-foot__content">
          <div :xs="24" :sm="12">
            <div class="web-page-footer_title">
              {{ $t(`Common.title.name`) }}
            </div>
            <div>{{ $t(`Common.title.address`) }}</div>
            <div>{{ $t(`Common.title.email`) }}</div>
            <div>
              <div>
                <a
                  style="
                    color: rgb(255, 255, 255);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.about-us'),
                      $t('floats.content.about-us')
                    )
                  "
                  >{{ this.$t('floats.title.about-us') }}
                </a>
                <a
                  style="
                    color: rgb(255, 255, 255);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.contact-us'),
                      $t('floats.content.contact-us')
                    )
                  "
                  >{{ this.$t('floats.title.contact-us') }}
                </a>
                <a
                  style="
                    color: rgb(255, 255, 255);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.privacy'),
                      $t('floats.content.privacy')
                    )
                  "
                  >{{ this.$t('floats.title.privacy') }}<br
                /></a>
              </div>
            </div>
          </div>
          <div :xs="24" :sm="12">
            <div class="web-page-footer_item">
              {{ $t(`Common.title.phone`) }}
            </div>
            <div>{{ $t(`Common.title.fax`) }}</div>
            <div>{{ $t('Common.title.reserved') }}</div>
          </div>
        </div>
      </div>
    </div>
    <m-modal
      :visible.sync="modalVisible"
      :title="modalTitle"
       @cancel="modalVisible = false"
      closable
    >
      <div v-html="modalHtml"></div>

      <template #footer>
        <m-button type="primary" @click="modalVisible = false">
          {{ $t('Common.action.close') }}
        </m-button>
      </template>
    </m-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalVisible: false,
      modalTitle: '',
      modalHtml: '',
    };
  },
  methods: {
    changeLang(key) {
      this.$i18n.locale = key;
      localStorage.setItem('currentLanguage', key);
      location.reload();
    },
    showModal(title, html) {
      this.modalVisible = true;
      this.modalTitle = title;
      this.modalHtml = html;
    },
  },
  computed: {
    hasFooter() {
      return !!this.$slots.actions;
    },
  },
};
</script>
<style scoped lang="scss">
.header_title {
  color: #ffffff;
  font-size: 24px;
}
.center-content {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  justify-content: center; /* 垂直置中 */
  align-items: center; /* 水平置中 */
}
.logo {
  display: flex;
  align-items: center;
}
.app-header {
  background: url('@/assets/banner.png') no-repeat;
  background-size: cover;
  padding: 10px;
  min-height: 100px;
}
.web-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}
.web-page__content,
.web-page-actions__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px 8px;
  width: 100%;
  flex: 1;
}
.web-page__content.has-footer {
  padding-bottom: 68px;
}
.web-page-foot__content {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0 auto;
  padding: 0px 20px;
  max-width: 1200px;
  font-weight: 500;
}
.web-page-footer {
  padding-top: 20px;
  padding-bottom: 20px;
  color: #ffffff;
  background-image: url('@/assets/footer.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 14px;
  .web-page-footer_title {
    font-size: 18px;
    color: #ffffff;
  }
}
.web-page-actions__content {
  height: 100%;
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: flex-end;
}
.logo-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.language-button.lang-active {
  color: #ffffff;
  text-decoration: underline;
}
.language-button {
  color: #bbdefb;
}
.lang-btn span {
  cursor: pointer;
  padding: 10px;
}
@media screen and (max-width: 767px) {
  .web-page-footer {
    padding-top: 20px;
    background-image: url('@/assets/app_bottom.png') !important;
  }
  .web-page-foot__content {
    display: block !important;
    text-align: center;
    margin-top: 20px;
  }
}
</style>
